import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import EditIcon from "@mui/icons-material/Delete";
import AgregarFacturasnoContampladasModal from "./AgregarFacturasnoContempladasModa";
import EditarFacturasnoContampladasModal from "./EditarFacturasnoContempladasModal";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";

export const FacturasNoContempladasScreen = () => {
  const history = useHistory();
  const [documentos, setDocumentos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [selectedID, setSelectedID] = useState();

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModalEditar = (documento) => {
    // setSelectedID(id);
    // setOpenModalEditar(true);
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturasNoContemplar/Eliminar?documento=${documento}`)
      .then((result) => {
        setDocumentos(result);
        Swal.fire(
          "DIFERENCIAS DE CONTRATO",
          "Registro eliminado con exito",
          "erro"
        );
      })
      .catch((error) => {
        Swal.fire("DIFERENCIAS DE CONTRATO", JSON.stringify(error), "error");
      })
      .finally(() => setLoader({ ...loader, mostrar: false }));
  };
  const handleCloseModalEditar = () => {
    setSelectedID(null);
    setOpenModalEditar(false);
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturasNoContemplar/Listado`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDocumentos(result);
        return;
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        return;
      });
    setLoader({ ...loader, mostrar: false });
  }, [openModal, openModalEditar]);

  return (
    <PlantillaScreen
      titulo={`DIFERENCIAS EN CONTRATOS JDF`}
      className={"facturas-nocontempladas-main-screen"}
      className_main={1}
    >
      <div className="facturas-nocontempladas-actions">
        <div
          className="facturas-nocontempladas-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="buttons">
          <button
            className="facturas-nocontempladas-header-agregar-objecion"
            onClick={() => handleOpenModal()}
          >
            <AddCircleOutlineIcon /> Agregar
          </button>
        </div>
      </div>
      <div className="facturas-nocontempladas">
        <LoaderScreen loader={loader} />
        <div className="facturas-nocontempladas-header">
          <div className="facturas-nocontempladas-header-title">
            <FormatListNumberedIcon /> Listado de facturas con diferencias en
            contratos
          </div>
        </div>
        <div className="facturas-nocontempladas-container scroll-4">
          <table>
            <thead>
              <tr>
                <th>Documento</th>
                <th>
                  <div>Rason Social</div>
                </th>
                <th>
                  <div>Fecha</div>
                </th>
                <th>
                  <div>Importe</div>
                </th>
                <th>
                  <div>Saldo</div>
                </th>
                <th>
                  <div>Comentarios</div>
                </th>
                <th>
                  <div style={{ color: "transparent" }}>.</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {documentos.map((doc) => (
                <tr key={doc.documento}>
                  <td className="documento-celda">{doc.documento}</td>
                  <td className="razonsocial-celda">{doc.razonsocial}</td>
                  <td className="fecha-celda">{doc.fecha}</td>
                  <td className="importe-celda">
                    {FormatMoney(doc.importefactura)}
                  </td>
                  <td className="saldo-celda">{FormatMoney(doc.saldo)}</td>
                  <td className="comentarios-celda">{doc.comentarios}</td>
                  <td className="ta-editar">
                    <div className="facturas-nocontempladas-acciones-listado">
                      <div
                        className="boton-editar-facturas-nocontempladas"
                        onClick={() => handleOpenModalEditar(doc.documento)}
                      >
                        <EditIcon /> Eliminar
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AgregarFacturasnoContampladasModal
          open={openModal}
          onClose={handleCloseModal}
          //   folio={folio}
        />
        <EditarFacturasnoContampladasModal
          open={openModalEditar}
          onClose={handleCloseModalEditar}
          documento={selectedID}
        />
      </div>
    </PlantillaScreen>
  );
};
